module.exports = __webpack_public_path__ + "img/form-banner.afd270c9.png";